import { ResultData } from 'servicesCommon/apiTypes';
import {
	PersonalUserDetails,
	Omit,
	CustomerPaymentMethod,
	ReferenceFieldWithName,
	AlternativeContact,
	NotificationsByEmail,
	PassengerInfo,
	JourneyNotes,
	ReferenceField
} from 'app-types';

export interface UserProfileCustomerInfoData {
	name: string;
	mainContactPhoneNumber: string;
	customerPaymentMethod: CustomerPaymentMethod;
	referenceFields: ReferenceFieldWithName[];
}

export interface UserInfoRequest {
	customerUserId: string;
}

export interface AlternativeContactWithNotifications extends AlternativeContact, NotificationsByEmail { }

export interface UserInfo extends Omit<PersonalUserDetails, 'alternativeContactList'> {
	userName: string;
	alternativeContactList: AlternativeContactWithNotifications[]
}

export interface BookingPassengerInfo extends PassengerInfo, JourneyNotes {
	referenceFields?: ReferenceField[];
}

export type UserInfoResponse = ResultData<UserInfo>;

export interface UpdateUserProfile extends Omit<PersonalUserDetails, 'creditCards'> {
	paymentMethodIds: string[];
}

export const FORM_STRUCTURE = {
	FIRST_NAME: 'firstName',
	LAST_NAME: 'lastName',
	EMAIL_ADDRESS: 'emailAddress',
	PASSWORD: 'password',
	USER_ADDRESS_PLACE_ID: 'userAddressPlaceId',
	PREFERRED_SERVICE_TYPE: 'preferredServiceType',
	ALTERNATIVE_CONTACTS: 'alternativeContactList',
	PHONE_NUMBER: 'phoneNumber',
	PHONE_CODE: 'phoneCode',
	PHONE_CODE_COUNTRY_ID: 'phoneCodeCountryId',
	BOOKING_CONFIRMATION: 'bookingConfirmation',
	INVOICE_CONFIRMATION: 'invoiceConfirmation',
	CALENDAR_BOOKING_EVENT: 'calendarBookingEvent',
	JOURNEY_NOTES: 'journeyNotes',
	REFERENCE_FIELDS: 'referenceFields'
};

export type UserProfileCustomerInfoResponse = ResultData<UserProfileCustomerInfoData>;
